import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl md:text-2xl lg:text-3xl font-extrabold mb-2 text-secondary-300" }, "What would have made this deal better?", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-base lg:text-xl" }, "Leave us feedback to make your experience better", -1)
const _hoisted_3 = { class: "mb-4 mt-6 max-w-xl" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-start mt-3 md:mt-4" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "text-xs md:text-base text-white bg-green-600 hover:bg-green-800 rounded-md mr-4 py-2 px-4 focus:outline-none border-none"
  }, " Submit feedback ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("textarea", {
        id: "interest-only-details",
        class: "appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 text-gray-700",
        rows: "3",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.collectedData.comment) = $event))
      }, null, 512), [
        [_vModelText, _ctx.collectedData.comment]
      ])
    ]),
    _hoisted_4
  ], 32))
}